import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalvarsService } from 'src/app/services/globalvars.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'app-assign',
  templateUrl: './assign.component.html',
  styleUrls: ['./assign.component.css']
})
export class AssignDevicesComponent implements OnInit {

  public pageId = 0;

  deviceid = ''
  description = ''
  department_id = '';
  scenarios: any[] = [];
  selectedScenario = 0
  assigedScenarios: any[] = []

  constructor(
    private route: ActivatedRoute,
    private rest: RestService,
    private globalvar: GlobalvarsService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.pageId = params['id'];
    });
    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    this.rest.getDevice(tmpToken.accessToken, this.pageId)
      .then(value => {
        let val: any = value;
        this.deviceid = val[0].mac_address
        this.description = val[0].description
        this.department_id = val[0].department_id
      })
      .catch(err => {
        this.globalvar.storeToken('');
        this.router.navigateByUrl('/logon');
      })

    this.getScenarios(this.pageId)

    // Get assigned scenarios
    this.getAssignedScenarios(this.pageId)
  }

  cancel() {
    this.router.navigateByUrl('/devices');
  }

  remove(scenarioId: any) {
    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    this.rest.delAssignedScenarios(tmpToken.accessToken, scenarioId, this.pageId)
      .then(value => {
        this.getAssignedScenarios(this.pageId)
        this.getScenarios(this.pageId)
      })
      .catch(err => {

        this.globalvar.storeToken('');
        this.router.navigateByUrl('/logon');
      })
  }

  play(scenarioId: any) {
    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    this.rest.getScenario(tmpToken.accessToken, scenarioId)
    .then(value => {
      console.log(value)
      let val: any = value;
      this.rest.postPlayScenario(tmpToken.accessToken, this.deviceid, val[0].scenario )
      .then(value => {}).catch(err => {
        console.log(err)
      })
    })
    .catch(err => {
      this.globalvar.storeToken('');
      this.router.navigateByUrl('/logon');
    })
  }

  autoplay(scenarioId: any) {
    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    let assignedScenario = {
      deviceId: this.pageId,
      scenarioId: scenarioId
    }

    this.rest.putAssignedScenarios(tmpToken.accessToken, assignedScenario, scenarioId)
      .then(value => {
        this.getAssignedScenarios(this.pageId)
      })
      .catch(err => {

        this.globalvar.storeToken('');
        this.router.navigateByUrl('/logon');
      })
  }

  add() {
    if (this.selectedScenario == 0) {
      return
    }
    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    console.log(this.selectedScenario)
    let assignedScenario = {
      scenarioId: this.selectedScenario,
      deviceId: this.pageId
    }

    this.rest.postAssignedScenarios(tmpToken.accessToken, assignedScenario)
      .then(value => {
        this.getAssignedScenarios(this.pageId)
        this.getScenarios(this.pageId)
      })
      .catch(err => {
        this.globalvar.storeToken('');
        this.router.navigateByUrl('/logon');
      })

  }

  getAssignedScenarios(deviceId: any) {

    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    this.rest.getAssignedScenarios(tmpToken.accessToken, deviceId)
      .then(value => {
        this.assigedScenarios = []
        this.assigedScenarios.push(value)
      })
      .catch(err => {
        this.globalvar.storeToken('');
        this.router.navigateByUrl('/logon');
      })

  }

  getScenarios(deviceId: any) {
    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    this.rest.getScenariosToAssign(tmpToken.accessToken, deviceId)
      .then(value => {
        this.scenarios = []
        this.scenarios.push(value)
      })
      .catch(err => {
        this.globalvar.storeToken('');
        this.router.navigateByUrl('/logon');
      })
  }

  trackByMethod(index: number, el: any): number {
    console.log(index, el)
    return el.scenario_id;
  }

  trackSelectByMethod(index: number, el: any): number {
    console.log(index, el)
    return el.idid;
  }
}
